import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SuperhighlightChannels from './Components/SuperhighlightChannels';
import LayoutFourChannel from './Components/LayoutFourChannel';
import LayoutThreeChannel from './Components/LayoutThreeChannel';
import LayoutTwoChannel from './Components/LayoutTwoChannel';
import LayoutOneChannel from './Components/LayoutOneChannel';

class LandingComercialChannels extends Component {
  getPostersLayout = (groups = []) => {
    const itemsNumber = groups.length;

    switch (itemsNumber) {
        case 1:
            return <LayoutOneChannel groups={groups} />
        case 2:
            return <LayoutTwoChannel groups={groups} />
        case 3:
            return <LayoutThreeChannel groups={groups} />
        case 4:
            return <LayoutFourChannel groups={groups} />
        default:
            return <LayoutFourChannel groups={groups} />
    }
  };

  render() {
    const { superhighlight = {}, posters = {} } = this.props;

    const { highlight = [] } = superhighlight || {};
    const { groups = [] } = posters || {};

    const showSuperhighlight = highlight && highlight.length > 0;
    const showPosters = groups && groups.length > 0;
    
    return (
      <div className="landing-comercial-channels">
        { showSuperhighlight && (
            <SuperhighlightChannels highlight = {highlight[0]} /> 
        )}
        
        { showPosters && this.getPostersLayout(groups) }
      </div>
    );
  }
}

LandingComercialChannels.propTypes = {
  superhighlight: PropTypes.object,
  posters: PropTypes.object,
};

LandingComercialChannels.defaultProps = {
  superhighlight: {},
  posters: {},
};

export default LandingComercialChannels;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialChannels/index.jsx